import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery, transformResponse } from "../../common/services/api";
import Locale from "../../common/constants/Locale";

type ISODate = `${number}-${number}-${number}`;

export enum Auart {
  NotPrepaid = "ZMK",
  Prepaid = "ZMKV",
}

export type DebitorQuantityContract = {
  vbeln: string;
  posnr: number;
  auart: Auart;
  vtext: string;
  omeng: number;
  gueen: ISODate;
};

export type CustomerContractsResponse = {
  customerNumber: string;
  debitorQuantityContracts: DebitorQuantityContract[];
};

export const contractApi = createApi({
  reducerPath: `contractApi`,
  baseQuery: createBaseQuery("/customer"),
  tagTypes: ["Contracts", "languageDependent"],
  endpoints: builder => ({
    contracts: builder.query<
      CustomerContractsResponse | null,
      { customerId: string; language: string }
    >({
      providesTags: ["Contracts"],
      query: ({ customerId = "", language = Locale.ENGLISH }) =>
        `${customerId}/quantity-contract/${language}`,
      transformResponse,
    }),
  }),
});

export const { useContractsQuery } = contractApi;
